import { render, staticRenderFns } from "./addCRMInvoice.vue?vue&type=template&id=280fc0ae"
import script from "./addCRMInvoice.vue?vue&type=script&lang=js"
export * from "./addCRMInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports